import { createAction } from 'redux-actions';
import {
  createActionWithNestedPagination,
  generatePaginators,
  getPaginator,
} from 'utils/pagination';
import { feedChunk } from 'api/schema';
import queryString from 'query-string';
import keys from 'lodash/keys';

const placeFeedPaginatorURI = '/v1/users/me/places/{id}/feed_events';
const placeFeedPaginatorEntity = [feedChunk];
const placeFeedPaginators = generatePaginators(
  placeFeedPaginatorURI,
  placeFeedPaginatorEntity,
);

const requestPlaceFeed = createAction('PLACE_FEED_REQUEST');
const receivePlaceFeed = createActionWithNestedPagination('PLACE_FEED_SUCCESS');
const failPlaceFeed = createAction('PLACE_FEED_ERROR');

export const getPlaceFeedPage = (placeId, query = '') => dispatch => {
  dispatch(requestPlaceFeed());

  const paginator = getPaginator(
    placeFeedPaginators,
    placeId,
    placeFeedPaginatorURI,
    placeFeedPaginatorEntity,
    10,
  );

  const parsedQuery = queryString.parse(query);

  keys(parsedQuery).forEach(key => {
    paginator.set(key, parsedQuery[key]);
  });

  return paginator
    .get()
    .then(
      data => dispatch(receivePlaceFeed({ placeId, data })),
      error => dispatch(failPlaceFeed(error)),
    );
};
